import styled from 'styled-components';

export const RichTextStyled = styled.div`
  padding: ${props =>
    props.theme.spacing(props.$verticalPadding, props.$horizontalPadding)};
`;
